<div [class]="mapWrapperClass">
  @if (apiLoaded$ | async) {
    <div class="google-map-container">
      <google-map #googleMap width="100%" [height]="mapHeight">
        <map-marker
          *ngFor="let marker of markers"
          [position]="marker.position"
          [label]="marker.label"
          [title]="marker.title"
          [options]="marker.options"
        ></map-marker>
      </google-map>
    </div>
  }
</div>
